/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountEntity,
  CreateTenantDto,
  CustomerPortalDto,
  OrganizationEntity,
  SubscribeDto,
  SubscriptionEntity,
  TenantEntity,
  TenantPlanStatusEntity,
  TenantWithSignInMethodEntity,
  UpdateOrganizationDto,
  UpdateTenantDto,
  UrlEntity,
} from '../models/index';
import {
    AccountEntityFromJSON,
    AccountEntityToJSON,
    CreateTenantDtoFromJSON,
    CreateTenantDtoToJSON,
    CustomerPortalDtoFromJSON,
    CustomerPortalDtoToJSON,
    OrganizationEntityFromJSON,
    OrganizationEntityToJSON,
    SubscribeDtoFromJSON,
    SubscribeDtoToJSON,
    SubscriptionEntityFromJSON,
    SubscriptionEntityToJSON,
    TenantEntityFromJSON,
    TenantEntityToJSON,
    TenantPlanStatusEntityFromJSON,
    TenantPlanStatusEntityToJSON,
    TenantWithSignInMethodEntityFromJSON,
    TenantWithSignInMethodEntityToJSON,
    UpdateOrganizationDtoFromJSON,
    UpdateOrganizationDtoToJSON,
    UpdateTenantDtoFromJSON,
    UpdateTenantDtoToJSON,
    UrlEntityFromJSON,
    UrlEntityToJSON,
} from '../models/index';

export interface CreateMyOrganizationsTenantRequest {
    createTenantDto: CreateTenantDto;
}

export interface DeleteMyOrganizationsTenantRequest {
    tenantId: string;
}

export interface GetMyCheckoutUrlRequest {
    subscribeDto: SubscribeDto;
}

export interface GetMyCustomerPortalUrlRequest {
    customerPortalDto: CustomerPortalDto;
}

export interface GetMyOrganizationsTenantRequest {
    tenantId: string;
}

export interface GetMyOrganizationsTenantPlanStatusRequest {
    tenantId: string;
}

export interface GetMySubscriptionsRequest {
    organizationId: string;
}

export interface GetMySubscriptionsCheckoutUrlRequest {
    subscribeDto: SubscribeDto;
}

export interface GetMySubscriptionsCustomerPortalUrlRequest {
    customerPortalDto: CustomerPortalDto;
}

export interface GetTenantPlanStatusRequest {
    authTenantId: string;
}

export interface UpdateMyOrganizationRequest {
    updateOrganizationDto: UpdateOrganizationDto;
}

export interface UpdateMyOrganizationsTenantRequest {
    tenantId: string;
    updateTenantDto: UpdateTenantDto;
}

/**
 * 
 */
export class AccountApi extends runtime.BaseAPI {

    /**
     * 自分の組織を作成する。
     */
    async createMyOrganizationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織を作成する。
     */
    async createMyOrganization(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationEntity> {
        const response = await this.createMyOrganizationRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナントを1件登録する。
     */
    async createMyOrganizationsTenantRaw(requestParameters: CreateMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEntity>> {
        if (requestParameters['createTenantDto'] == null) {
            throw new runtime.RequiredError(
                'createTenantDto',
                'Required parameter "createTenantDto" was null or undefined when calling createMyOrganizationsTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTenantDtoToJSON(requestParameters['createTenantDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくテナントを1件登録する。
     */
    async createMyOrganizationsTenant(requestParameters: CreateMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEntity> {
        const response = await this.createMyOrganizationsTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナントを1件削除する。
     */
    async deleteMyOrganizationsTenantRaw(requestParameters: DeleteMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEntity>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteMyOrganizationsTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくテナントを1件削除する。
     */
    async deleteMyOrganizationsTenant(requestParameters: DeleteMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEntity> {
        const response = await this.deleteMyOrganizationsTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくサブスクリプション機能を有効化します。
     */
    async enableMySubscriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/subscriptions/enable`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくサブスクリプション機能を有効化します。
     */
    async enableMySubscriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationEntity> {
        const response = await this.enableMySubscriptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分のアカウント情報を取得する。
     */
    async getAccountRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AccountEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AccountEntityFromJSON(jsonValue));
    }

    /**
     * 自分のアカウント情報を取得する。
     */
    async getAccount(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AccountEntity> {
        const response = await this.getAccountRaw(initOverrides);
        return await response.value();
    }

    /**
     *  顧客がチェックアウトするためのページのURLを発行する。
     */
    async getMyCheckoutUrlRaw(requestParameters: GetMyCheckoutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlEntity>> {
        if (requestParameters['subscribeDto'] == null) {
            throw new runtime.RequiredError(
                'subscribeDto',
                'Required parameter "subscribeDto" was null or undefined when calling getMyCheckoutUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions/checkout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscribeDtoToJSON(requestParameters['subscribeDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlEntityFromJSON(jsonValue));
    }

    /**
     *  顧客がチェックアウトするためのページのURLを発行する。
     */
    async getMyCheckoutUrl(requestParameters: GetMyCheckoutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlEntity> {
        const response = await this.getMyCheckoutUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 顧客が各自でサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。
     */
    async getMyCustomerPortalUrlRaw(requestParameters: GetMyCustomerPortalUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlEntity>> {
        if (requestParameters['customerPortalDto'] == null) {
            throw new runtime.RequiredError(
                'customerPortalDto',
                'Required parameter "customerPortalDto" was null or undefined when calling getMyCustomerPortalUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions/portal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerPortalDtoToJSON(requestParameters['customerPortalDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlEntityFromJSON(jsonValue));
    }

    /**
     * 顧客が各自でサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。
     */
    async getMyCustomerPortalUrl(requestParameters: GetMyCustomerPortalUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlEntity> {
        const response = await this.getMyCustomerPortalUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織情報を取得する。
     */
    async getMyOrganizationRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationEntity>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織情報を取得する。
     */
    async getMyOrganization(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationEntity> {
        const response = await this.getMyOrganizationRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナントを1件取得する。
     */
    async getMyOrganizationsTenantRaw(requestParameters: GetMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEntity>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getMyOrganizationsTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくテナントを1件取得する。
     */
    async getMyOrganizationsTenant(requestParameters: GetMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEntity> {
        const response = await this.getMyOrganizationsTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナント1件のプラン状況を取得する。
     */
    async getMyOrganizationsTenantPlanStatusRaw(requestParameters: GetMyOrganizationsTenantPlanStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEntity>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getMyOrganizationsTenantPlanStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants/{tenantId}/plan`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくテナント1件のプラン状況を取得する。
     */
    async getMyOrganizationsTenantPlanStatus(requestParameters: GetMyOrganizationsTenantPlanStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEntity> {
        const response = await this.getMyOrganizationsTenantPlanStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくサブスクリプションを全て取得する。
     */
    async getMySubscriptionsRaw(requestParameters: GetMySubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getMySubscriptions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/subscriptions`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * 自分の組織に紐づくサブスクリプションを全て取得する。
     */
    async getMySubscriptions(requestParameters: GetMySubscriptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getMySubscriptionsRaw(requestParameters, initOverrides);
    }

    /**
     *  自分の組織に紐づくサブスクリプションをチェックアウトするためのページのURLを発行する。
     */
    async getMySubscriptionsCheckoutUrlRaw(requestParameters: GetMySubscriptionsCheckoutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlEntity>> {
        if (requestParameters['subscribeDto'] == null) {
            throw new runtime.RequiredError(
                'subscribeDto',
                'Required parameter "subscribeDto" was null or undefined when calling getMySubscriptionsCheckoutUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/subscriptions/checkout`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SubscribeDtoToJSON(requestParameters['subscribeDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlEntityFromJSON(jsonValue));
    }

    /**
     *  自分の組織に紐づくサブスクリプションをチェックアウトするためのページのURLを発行する。
     */
    async getMySubscriptionsCheckoutUrl(requestParameters: GetMySubscriptionsCheckoutUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlEntity> {
        const response = await this.getMySubscriptionsCheckoutUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。
     */
    async getMySubscriptionsCustomerPortalUrlRaw(requestParameters: GetMySubscriptionsCustomerPortalUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UrlEntity>> {
        if (requestParameters['customerPortalDto'] == null) {
            throw new runtime.RequiredError(
                'customerPortalDto',
                'Required parameter "customerPortalDto" was null or undefined when calling getMySubscriptionsCustomerPortalUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/subscriptions/portal`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CustomerPortalDtoToJSON(requestParameters['customerPortalDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UrlEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくサブスクリプションと請求詳細を管理するためのカスタマーポータルのURLを発行する。
     */
    async getMySubscriptionsCustomerPortalUrl(requestParameters: GetMySubscriptionsCustomerPortalUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UrlEntity> {
        const response = await this.getMySubscriptionsCustomerPortalUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報を全て取得する。
     */
    async getMyTenantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/tenants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantEntityFromJSON));
    }

    /**
     * 自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報を全て取得する。
     */
    async getMyTenants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantEntity>> {
        const response = await this.getMyTenantsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報とログイン方法を全て取得する。
     */
    async getMyTenantsWithSignInMethodRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantWithSignInMethodEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/tenants/signInMethod`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantWithSignInMethodEntityFromJSON));
    }

    /**
     * 自分のアカウントのメールアドレスを持つユーザーが登録されているテナント情報とログイン方法を全て取得する。
     */
    async getMyTenantsWithSignInMethod(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantWithSignInMethodEntity>> {
        const response = await this.getMyTenantsWithSignInMethodRaw(initOverrides);
        return await response.value();
    }

    /**
     * 利用した無料トライアルのサブスクリプションを取得する
     */
    async getMyTrialSubscriptionRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions/trial`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionEntityFromJSON));
    }

    /**
     * 利用した無料トライアルのサブスクリプションを取得する
     */
    async getMyTrialSubscription(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionEntity>> {
        const response = await this.getMyTrialSubscriptionRaw(initOverrides);
        return await response.value();
    }

    /**
     * 利用した無料トライアルのサブスクリプションを取得する
     */
    async getTenantPlanStatusRaw(requestParameters: GetTenantPlanStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantPlanStatusEntity>> {
        if (requestParameters['authTenantId'] == null) {
            throw new runtime.RequiredError(
                'authTenantId',
                'Required parameter "authTenantId" was null or undefined when calling getTenantPlanStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions/tenantPlanStatus/{authTenantId}`.replace(`{${"authTenantId"}}`, encodeURIComponent(String(requestParameters['authTenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantPlanStatusEntityFromJSON(jsonValue));
    }

    /**
     * 利用した無料トライアルのサブスクリプションを取得する
     */
    async getTenantPlanStatus(requestParameters: GetTenantPlanStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantPlanStatusEntity> {
        const response = await this.getTenantPlanStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナント情報を全て取得する。
     */
    async listMyOrganizationsTenantsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<TenantEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(TenantEntityFromJSON));
    }

    /**
     * 自分の組織に紐づくテナント情報を全て取得する。
     */
    async listMyOrganizationsTenants(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<TenantEntity>> {
        const response = await this.listMyOrganizationsTenantsRaw(initOverrides);
        return await response.value();
    }

    /**
     * プラン一覧を取得する。
     */
    async listMyPlansRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions/plans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionEntityFromJSON));
    }

    /**
     * プラン一覧を取得する。
     */
    async listMyPlans(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionEntity>> {
        const response = await this.listMyPlansRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分のアカウントに紐づくサブスクリプション一覧を取得する。
     */
    async listMySubscriptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SubscriptionEntity>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/subscriptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SubscriptionEntityFromJSON));
    }

    /**
     * 自分のアカウントに紐づくサブスクリプション一覧を取得する。
     */
    async listMySubscriptions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SubscriptionEntity>> {
        const response = await this.listMySubscriptionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織を更新する。
     */
    async updateMyOrganizationRaw(requestParameters: UpdateMyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrganizationEntity>> {
        if (requestParameters['updateOrganizationDto'] == null) {
            throw new runtime.RequiredError(
                'updateOrganizationDto',
                'Required parameter "updateOrganizationDto" was null or undefined when calling updateMyOrganization().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateOrganizationDtoToJSON(requestParameters['updateOrganizationDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織を更新する。
     */
    async updateMyOrganization(requestParameters: UpdateMyOrganizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrganizationEntity> {
        const response = await this.updateMyOrganizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 自分の組織に紐づくテナントを1件更新する。
     */
    async updateMyOrganizationsTenantRaw(requestParameters: UpdateMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantEntity>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateMyOrganizationsTenant().'
            );
        }

        if (requestParameters['updateTenantDto'] == null) {
            throw new runtime.RequiredError(
                'updateTenantDto',
                'Required parameter "updateTenantDto" was null or undefined when calling updateMyOrganizationsTenant().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Authorization", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-tenant-id"] = await this.configuration.apiKey("x-tenant-id"); // Tenant authentication
        }

        const response = await this.request({
            path: `/api/v1/account/my/organization/tenants/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTenantDtoToJSON(requestParameters['updateTenantDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantEntityFromJSON(jsonValue));
    }

    /**
     * 自分の組織に紐づくテナントを1件更新する。
     */
    async updateMyOrganizationsTenant(requestParameters: UpdateMyOrganizationsTenantRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantEntity> {
        const response = await this.updateMyOrganizationsTenantRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
